var CryptoJS = require("crypto-js");

export function notificationOptions(message, type) {
  return {
    place: "tr",
    message: (
      <div>
        <div>{message}</div>
      </div>
    ),
    type: type,
    icon: "nc-icon nc-bell-55",
    autoDismiss: 7,
  };
}

export function validCookieExists() {
  let cookie = localStorage.getItem("FTBCookie");
  if (!cookie) return false;
  return true;
}

export function getAuthorizationHeader() {
  let cookie = localStorage.getItem("FTBCookie");
  return `Bearer ${cookie}`;
}

export function isUserAdmin() {
  let userInfoStorage = localStorage.getItem("userInfo");
  if (!userInfoStorage) return false;
  let userInfo = JSON.parse(userInfoStorage);
  if (userInfo.role_id == 1) return true;
  return false;
}

export function isUserTranslator() {
  let userInfoStorage = localStorage.getItem("userInfo");
  if (!userInfoStorage) return false;
  let userInfo = JSON.parse(userInfoStorage);
  if (userInfo.role_id == 4) return true;
  return false;
}

export function getUserData() {
  let userInfoStorage = localStorage.getItem("userInfo");
  if (!userInfoStorage) return null;
  return JSON.parse(userInfoStorage);
}

export async function setUserData(data) {
  let userInfoStorage = localStorage.getItem("userInfo");
  if (!userInfoStorage) return null;
  let tempUserInfo = JSON.parse(userInfoStorage);
  tempUserInfo[data.key] = data.value;
  localStorage.setItem("userInfo", JSON.stringify(tempUserInfo));
  return tempUserInfo;
}

export function getUserRole() {
  let userInfoStorage = localStorage.getItem("userInfo");
  if (!userInfoStorage) return null;
  let roles = JSON.parse(userInfoStorage).roles;
  return roles;
}

export function getError() {
  let error = localStorage.getItem("error");
  return error;
}

export function setError(error) {
  localStorage.setItem("error", JSON.stringify(error));
  return error;
}

export function delError(error) {
  localStorage.removeItem("error");
  return error;
}

export function decrypt(data) {
  var bytes = CryptoJS.AES.decrypt(data.data[0], data.data[1].toString(CryptoJS.enc.Hex));
  var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

  return decryptedData;
}
